import React from 'react';
import { getTheme, IStyle, ITheme, mergeStyles } from '@fluentui/react';
import { IHorizontalRuleComponentModel } from '../../parser/horizontal-rule';

const getStyleClass = (theme: ITheme, isThick: boolean) => {
  const style: IStyle = {
    margin: '2.5em 0',
    padding: 0,
    border: 'none',
    backgroundColor: theme.palette.neutralTertiary,
    height: isThick ? 6 : 1,
  };

  return mergeStyles([ style ]);
}

export const MarkdownHorizontalRule: React.FunctionComponent<IHorizontalRuleComponentModel> = (props) => {
  const theme = getTheme();
  const styleClass = getStyleClass(theme, props.isThick);

  return (
    <hr className={styleClass} />
  );
};
